import { createContext, type FC, type PropsWithChildren, useState } from 'react';
import BpmnModeler from 'camunda-bpmn-js/lib/camunda-platform/Modeler';
import 'camunda-bpmn-js/dist/assets/camunda-platform-modeler.css';
import 'bpmn-js-bpmnlint/dist/assets/css/bpmn-js-bpmnlint.css';
import 'bpmn-js-token-simulation/assets/css/bpmn-js-token-simulation.css';
import { SpSiteListsProvider } from '../providers/SpSiteListsProvider';
import { initModeler } from '../../initModeler';
import { SpActiveProcessesProvider } from '../providers/ActiveProcessListsProvider';
import { SpSubSitesProvider } from '../providers/SpSubSitesProvider';

export const ModelerContext = createContext<BpmnModeler>(initModeler());

export const ModelerProvider: FC<PropsWithChildren> = (props) => {
    const [modeler] = useState<BpmnModeler>(initModeler);
    return (
        <ModelerContext.Provider value={modeler}>
            {props.children}
            {/*<SpSitesProvider />*/}
            <SpSiteListsProvider />
            <SpSubSitesProvider />
            <SpActiveProcessesProvider />
        </ModelerContext.Provider>
    );
};
